module.exports = __webpack_public_path__ + "img/couple-dependant.9f10af37.svg";